<div
  class="app-container"
  [ngClass]="{ 'call-in-progress': isCallInProgressRoute }"
>
  <main class="app-content">
    <div class="container">
      <router-outlet></router-outlet>

      <!-- PWA Installation Debugging Panel -->
      <!-- <div class="pwa-debug-panel" *ngIf="showDebugPanel">
        <h3>PWA Installation Debugging</h3>
        <div class="debug-actions">
          <button (click)="checkInstallationCriteria()">
            Check Installation Criteria
          </button>
          <button (click)="clearBrowserCache()" class="clear-cache-button">
            Clear Browser Cache
          </button>
          <p class="debug-note">
            Note: Installation is handled by the Home component
          </p>
        </div>

        <div class="installation-status">
          <h4>Installation Status</h4>
          <ul class="log-entries">
            <li *ngFor="let entry of installationLog">{{ entry }}</li>
            <li *ngIf="installationLog.length === 0">
              No installation events logged yet
            </li>
          </ul>
        </div>
      </div> -->
    </div>

    <button
      class="install-button"
      *ngIf="installPrompt && agentName === null"
      (click)="installApp()"
    >
      <i class="material-symbols-outlined">vertical_align_bottom</i>
      Install App
    </button>
  </main>

  <!-- WellSky Bars Supergraphic - Hidden on call-in-progress page -->
  <div class="wellsky-supergraphic-container" *ngIf="!isCallInProgressRoute">
    <img
      src="assets/images/WellSky_Bars_Supergraphic_CMYK.png"
      alt="WellSky Bars Supergraphic"
      class="wellsky-supergraphic"
      [ngClass]="{ grayscale: isCallTranscriptRoute }"
    />
  </div>
</div>
